import { render, staticRenderFns } from "./ColorSetting.vue?vue&type=template&id=4bc0ee12&scoped=true&"
import script from "./ColorSetting.vue?vue&type=script&lang=js&"
export * from "./ColorSetting.vue?vue&type=script&lang=js&"
import style0 from "./ColorSetting.vue?vue&type=style&index=0&id=4bc0ee12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0ee12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc0ee12')) {
      api.createRecord('4bc0ee12', component.options)
    } else {
      api.reload('4bc0ee12', component.options)
    }
    module.hot.accept("./ColorSetting.vue?vue&type=template&id=4bc0ee12&scoped=true&", function () {
      api.rerender('4bc0ee12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/NavbarMenu/components/SettingAndTools/ColorSetting.vue"
export default component.exports